import { forwardRef } from 'react';
import cc from 'classcat';

import { InputProps } from '../types';
import css from '../Input/index.module.scss';

const formatPhoneNumber = (value: string): string => {
  // if input value is falsy eg if the user deletes the input, then just return
  if (!value) return value;

  // Filter only numbers from the input
  const cleaned = ('' + value).replace(/\D/g, '');

  // Check if the input is of correct
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    // Remove the matched extension code
    // Change this to format for any country code.
    const intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }

  return cleaned;
};

type Ref = HTMLInputElement;
const Input = forwardRef<Ref, InputProps>(
  (
    {
      autoComplete,
      helpText,
      hideLabel,
      id,
      label,
      link,
      onChange,
      onFocus,
      name,
      placeholder,
      required,
      type,
      value,
      withIcon,
    },
    ref,
  ) => {
    const forId = id || `input-${name}`;
    const rootClass = cc([css.root, { [css.withIcon]: withIcon }, { [css.radioLabel]: type === 'radio' }]);
    const inputProps = {
      className: css.input,
      id: forId,
      link,
      name,
      onFocus,
      placeholder,
      ref,
      type,
      required,
      value: formatPhoneNumber(String(value)),
    };

    inputProps['onChange'] = ({ target: { name, value } }) => {
      onChange({ target: { name, value: formatPhoneNumber(value) } });
    };

    if (autoComplete) {
      inputProps['autoComplete'] = autoComplete;
    }

    return (
      <>
        <label className={rootClass} htmlFor={forId}>
          <div className={cc([css.label, { [css.hideLabel]: hideLabel }])}>{label}</div>
          <div className={css.inputWrap}>
            <input {...inputProps} />
          </div>
        </label>
        {helpText && <div className={css.helpText} dangerouslySetInnerHTML={{ __html: helpText }} />}
        {link && <div className={css.link}>{link}</div>}
      </>
    );
  },
);
/* eslint-disable @typescript-eslint/no-empty-function */
Input.defaultProps = {
  autoComplete: '',
  id: '',
  onFocus: () => {},
  placeholder: '',
  required: false,
  type: 'text',
  value: '',
};
export default Input;
